import React from 'react';

class NotFoundIndex extends React.Component<{}, {}> {
    public render() {
        return <React.Fragment>
            <section className="section">
                <div className="deck">
                    <div className="w--md banner-title">
                        <h2>Side ikke fundet (404)</h2>
                        <p>Vi kan desværre ikke finde den side, du leder efter.</p>
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }
}

export default NotFoundIndex;